import { Alert, Card } from 'tunggal';
import React from 'react';
export default {
  Alert,
  Card,
  React
};